export default "__VITE_ASSET__1j2hFOWB__"